module.exports = __webpack_public_path__ + "static/media/indd.fde2ec64.svg";